import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Grid from "@material-ui/core/Grid";
import { Box, Button } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import HeaderTypography from "../components/v2/Typography/HeaderTypography.js";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography.js";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import { Hidden } from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";
import GenericAdForm from "../components/Form/genericAdForm.js";
import { Link } from "gatsby";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CheckIcon from "@material-ui/icons/Check";
import { makeStyles } from "@material-ui/core/styles";
import LogoFavicon from "../images/v2/PC-logo_favicon.svg";
import HorizontalLogo from "../images/v2/campaigns/Horizontal-logo.png";
import Logo from "../images/v2/PC-vertical-logo.svg";
import callImg from "../images/v2/campaigns/call.svg";
import Divider from "@material-ui/core/Divider";
import ChannelImg from "../images/v2/campaigns/sales-process/channel.svg";
import singaporeSmeBannerImg from "../images/v2/campaigns/Mask-Group-250.png";
import singaporeSmeBannerRightImg from "../images/v2/campaigns/Group10618.png";
import singaporeSmeSalesCRMImg from "../images/v2/campaigns/singapore-sme-sales-crm-img.png";
import pepperCloudCRMHelpsBg from "../images/v2/campaigns/line-bg.svg";
import pepperCloudCRMHelpsContentBg from "../images/v2/campaigns/crm-helps-content-bg.svg";
import singaporeSmeFromImg from "../images/v2/campaigns/watermark.svg";
import salesManagement from "../images/v2/campaigns/sales-process/sales.svg";
import quotationManagement from "../images/v2/campaigns/sales-process/quotation.svg";
import leadManagement from "../images/v2/campaigns/sales-process/lead.svg";
import campaignManagement from "../images/v2/campaigns/sales-process/campaign.svg";
import salesForcasting from "../images/v2/campaigns/sales-process/forecast.svg";
import teamManagement from "../images/v2/campaigns/sales-process/team.svg";
import securityManagement from "../images/v2/campaigns/sales-process/security.svg";
import formSuccessImg from "../images/v2/campaigns/form-success-img.svg";
import useWidth from "../hooks/useWidth.js";
import PCLandingPageTestimonial from "../components/v2/HomeSlider/PCLandingPageTestimonial.js";
import requestDemoBGImg from "../images/v2/campaigns/request-demo-bg.svg";
import loadable from "@loadable/component";
import WhiteButton from "../components/v2/WhightButton.js";
import IntegratedCRMBgImg from "../images/v2/home/integrated-crm-bg.svg";
import PCBenefits from "../images/v2/campaigns/PCBenefits.png";
import singaporeSmeTestimonialImg from "../images/v2/campaigns/Home page creative  v1.jpg";
import TechDataLogo from "../images/v2/client-logos/tech-data-pepper-cloud-customer.png";
import smeSupportedByLogo from "../images/v2/campaigns/sme-support-by-logo.png";
import smeInSupportOfLogo from "../images/v2/campaigns/sme-in-support-of-logo.png";
// import { conversionEventOnCall } from "./singapore-sme-v2.js";
import RequestCallBackModal from "../components/RequestCallBackModal.js.js";
import SEO from "../components/SEO.js";
import IMDALockup from "../components/v4/IMDALockup/IMDALockup.jsx";

export const conversionEventOnCall = () => {
  if (typeof window.gtag === "function")
    window.gtag("event", "conversion", {
      send_to: "AW-615460128/prVoCM7gjuwBEKDavKUC",
    });
};

const useStyles = makeStyles((theme) => ({
  marginAuto: {
    margin: "0 auto",
  },
  imdaStyle:{
    [theme.breakpoints.down("sm")]: {
      padding: "0px 16px",
      },
  },
  header: {
    boxShadow: "0 2px 4px 0 rgba(0,0,0,.29)",
    padding: ".65rem 0 .25rem",
  },
  backgroundWhite: {
    position: `relative`,
    backgroundColor: `#fff`,
  },
  singaporeSmeBanner: {
    position: `relative`,
    background: `#fff url(${singaporeSmeBannerImg}) no-repeat center`,
    backgroundSize: "cover",
    overflow: "hidden",
    paddingTop: "50px",
    [theme.breakpoints.up(1600)]: {
      position: `relative`,
      background: `#fff url(${singaporeSmeBannerImg}) no-repeat center`,
      backgroundSize: "cover",
    },
  },
  singaporeSmeBannerRightImg: {
    position: `absolute`,
    background: `transparent url(${singaporeSmeBannerRightImg}) no-repeat`,
    backgroundSize: "contain",
    paddingTop: "50px",
    right: `-25%`,
    backgroundPosition: `right`,
    width: `100%`,
    height: `100%`,
    top: `25%`,
    [theme.breakpoints.down(1120)]: {
      display: `none`,
    },
    [theme.breakpoints.up(1300)]: {
      right: `-20%`,
    },
    [theme.breakpoints.up(1600)]: {
      right: `-15%`,
    },
    [theme.breakpoints.up(1900)]: {
      right: `0%`,
    },
  },
  singaporeSmeFromBox: {
    [theme.breakpoints.up("md")]: {
      paddingTop: "4rem",
    },
  },
  listItem: {
    paddingLeft: "0px",
  },
  listItemText: {
    "& *": {
      fontSize: 18,
      color: "#2e3f4f",
      [theme.breakpoints.down("sm")]: {
        fontSize: 16,
      },
    },
  },
  listItemIcon: {
    color: "#2db45e",
    fontSize: 26,
    backgroundColor: "#d5f0df",
    borderRadius: "50%",
    padding: "5px",
    // marginRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: 28,
      // marginRight: theme.spacing(1.5),
    },
  },
  singaporeSmeFrom: {
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 2px 5px 0 #b7b7b7",
    maxWidth: "430px",
    backgroundSize: "430px 522px",
    position: "relative",
    zIndex: "1",
    margin: "0 auto",
  },
  singaporeSmeFromHeader: {
    background: "#2e3f4f",
    borderRadius: "10px 10px 0 0",
    padding: ".6rem .25rem",
    letterSpacing: ".32px",
    fontSize: "24px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  salesProcessCard: {
    border: "none",
    boxShadow: "none",
    // backgroundColor: "transparent",
    marginBottom: theme.spacing(4),
  },
  cardHeaderAvatar: {
    height: 100,
    width: 100,
    background: "#FFF",
    boxShadow: "1px 1px 7px 0 rgb(0 0 0 / 19%)",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: -68,
    [theme.breakpoints.down("sm")]: {
      height: 60,
      width: 60,
    },
  },
  img: {
    backgroundSize: "contain",
  },
  nopad: {
    paddingLeft: "0",
    paddingTop: "0",
  },
  nopadtpbtm: {
    paddingTop: "0",
    paddingBottom: "0",
  },
  colorChange: {
    color: "#ff7a59",
    fontSize: "30px",
    fontWeight: "700",
    letterSpacing: ".4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  cardHeader: {
    background: "#f2f7fd",
    marginLeft: 54,
    // [theme.breakpoints.down("sm")]: {
    // 	alignItems: "end !important",
    // },
  },
  landingbtn: {
    padding: "10px 45px",
    fontSize: "22px",
    borderRadius: "5px",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      padding: "10px 35px",
      fontSize: "18px",
    },
  },
  IntegratedCRMBg: {
    background: `url(${IntegratedCRMBgImg}) center bottom no-repeat`,
    backgroundSize: "cover",
  },
  whitespaceNowrap: {
    whiteSpace: "nowrap",
  },
  pepperCloudCRMHelps: {
    [theme.breakpoints.up("md")]: {
      background: `url(${pepperCloudCRMHelpsBg}) no-repeat`,
      backgroundSize: "100%",
      backgroundPosition: "center",
    },
  },
  pepperCloudCRMHelpsSpan: {
    [theme.breakpoints.up("md")]: {
      backgroundColor: "#ffffff",
      padding: "0 1rem",
    },
  },
  pepperCloudCRMHelpsContent: {
    background: `url(${pepperCloudCRMHelpsContentBg}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  pepperCloudCRMHelpsContentListBox: {
    boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.16)",
    backgroundColor: "#ffffff",
    padding: "2rem 1rem",
  },
  pepperCloudCRMHelpsContentList: {
    listStyle: "none",
    padding: "0px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  },
  pepperCloudCRMHelpsContentListItem: {
    display: "inline-block",
    paddingRight: "1rem",
    marginRight: "1rem",
    fontSize: "20px",
    [theme.breakpoints.down("sm")]: {
      borderRight: "none !important",
    },
    "&:not(:last-of-type)": {
      borderRight: "1px solid rgba(112, 112, 112, .5)",
    },
  },
  pepperCloudCRMHelpsContentListItemSpan: {
    fontSize: "36px",
    color: "#088937",
    paddingRight: "1rem",
    lineHeight: "normal",
  },
  requestDemoRoot: {
    background: `url(${requestDemoBGImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  ConnectCrm: {
    background: "#ebf9fc",
    padding: "20px",
  },
  PCBenefits: {
    position: `relative`,
    background: `transparent url(${PCBenefits}) no-repeat center`,
    backgroundSize: "contain",
    backgroundPosition: "initial",
    width: "100%",
    height: "768px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "407.7px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "417px",
    },
  },
  PCBenefitsText: {
    width: "488px",
    fontFamily: "Poppins",
    fontSize: "35px",
    fontWeight: "600",
    textAlign: "left",
    color: "#fff",
    paddingTop: "264px",
    paddingLeft: "54px",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "147px",
      paddingLeft: "12px",
      width: "100%",
      fontSize: "28px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "308px",
      paddingTop: "166px",
      paddingLeft: "23px",
      fontSize: "25px",
    },
  },
  PCBenefitsList: {
    paddingTop: "70px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "-38px",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "12px",
    },
  },
  smeBannerTxthead: {
    padding: "3px",
    margin: "0",
    marginLeft: "5px",
  },
  martop: {
    marginTop: "10px",
  },
  listItemTextTitle: {
    color: "#2e3f4f",
    fontFamily: "Poppins,sans-serif",
    fontSize: "18px",
    fontWeight: "500",
    marginTop: "0px",
    fontFamily: "Poppins, sans-serif",
    marginBottom: "8px",
    [theme.breakpoints.up("xs")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("sm")]: {
      marginBottom: "0px",
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: "0px",
      fontSize: "18px",
    },
  },
  listItemTextDescription: {
    color: "#2e3f4f",
    paddingBottom: "20px",
    margin: "0px",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "1.56",
    letterSpacing: "0.56px",
    [theme.breakpoints.up("xs")]: {
      paddingBottom: "30px",
      fontSize: "18px",
    },
    [theme.breakpoints.up("sm")]: {
      paddingBottom: "0px",
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      paddingBottom: "25px",
      fontSize: "16px",
    },
  },
  listStyle: {
    color: " #0698b4",
  },
  listContainer: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
  copyFooter: {
    color: "#cbcccd",
    textAlign: "end",
    paddingRight: "23px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
    },
  },
}));

const listOne = `Upto 50% business grant approved
Single unified platform`.split(`
`);

const listTwo = `Send personal & bulk messages
Local Singapore support 24*7`.split(`
`);

const benefitsList = [
  {
    title: "Increase your Sales",
    description: (
      <>
        Make your sales team more effective by helping them close deals faster.
        Track your sales team's performance in real-time.
      </>
    ),
  },
  {
    title: "Local Support",
    description: (
      <>
        Get 24*7 local support. Our experienced CRM consultants will work with
        your Sales team to optimise your team performance.
      </>
    ),
  },
  {
    title: "All-Integrated Product",
    description: (
      <>
        Integrate your email account, calendar, WhatsApp, SMS, and accounting
        software with Pepper Cloud CRM. Get all the information in one place
        when you need it.
      </>
    ),
  },
  {
    title: "Affordable",
    description: (
      <>
        Experience easy and simple CRM at an affordable price with Pepper Cloud.
        Pay per user and scale as per your requirements.
      </>
    ),
  },
  {
    title: "Avail business grant",
    description: (
      <>
        Claim upto 50% business grant for Pepper Cloud CRM. Leave all the tedious
        paperwork to us.{" "}
      </>
    ),
  },
  {
    title: "Save time and efforts of your team",
    description: (
      <>
        Provide your sales team with real-time alerts, automate lead capture,
        assign tasks, and create events. Eliminate manual data entry through
        enrichment provided by CRM.
      </>
    ),
  },
];

const CompanyCarousel = loadable(() =>
  import("../components/v2/CompanyCarousel.js")
);
const LazyLoad = loadable(() => import("react-lazyload"));
const GoogleAdV1 = () => {
  const [success, setSuccess] = React.useState(false);
  const handleSuccess = () => {
    setSuccess(true);
  };

  const myRef = React.useRef(null);

  const executeScroll = () => {
    myRef.current.scrollIntoView();
  };

  const classes = useStyles();

  const width = useWidth();

  return (
    <React.Fragment>
      {/* Header  */}
      <SEO
        noindex
        canonical="/crm-software-for-small-business-singapore/"
        description=" The best CRM software built just for small business in Singapore comes with various features and powerful integration to manage your sales and drive your business."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Pepper Cloud",
          legalName: "Pepper Cloud PTE LTD",
          url: "https://peppercloud.com/",
          logo: "https://peppercloud.com/icons/logo.png",
          foundingDate: "2017",
          address: [
            {
              "@type": "PostalAddress",
              streetAddress: "#04-01/02",
              addressLocality: "Blk 79 Ayer Rajah Crescent",
              addressRegion: "SG",
              postalCode: "139955",
              addressCountry: "Singapore",
            },
            {
              "@type": "PostalAddress",
              streetAddress:
                "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
              addressLocality: "Bengaluru",
              addressRegion: "KA",
              postalCode: "560095",
              addressCountry: "India",
            },
          ],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer support",
            telephone: "+6566562616",
            email: ["sales@peppercloud.com", "support@peppercloud.com"],
          },
          sameAs: [
            "https://twitter.com/peppercloudpte",
            "https://www.linkedin.com/company/peppercloud/",
            "https://www.facebook.com/PepperCloudPteLtd",
            "https://www.instagram.com/pepper.cloud/",
          ],
        }}
        keywords="crm software for small business singapore,CRM for SMEs,CRM system,Sales CRM system"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        title="Best CRM Software for Small Business Singapore | Pepper Cloud"
      />
      <Box className={classes.header}>
        <Box component={Container}>
          <Grid alignItems="center" container justify="center">
            <Grid item md={7} sm={12}>
              <Box
                alignItems="center"
                display="flex"
                justifyContent="flex-start"
                my={1}
              >
                <Box alignItems="center" display="flex">
                  <Link to="/">
                    <Box
                      alt="Pepper Cloud logo"
                      component={"img"}
                      height={{ sm: 36, xs: 36 }[width] || 58}
                      mr={{ sm: 1, xs: 1 }[width] || 2}
                      src={HorizontalLogo}
                    />
                  </Link>
                </Box>
              </Box>
            </Grid>
            <Grid item md={5} sm={12}>
              <Box
                alignItems="flex-end"
                display="flex"
                justifyContent="flex-end"
                my={1}
                textAlign="right"
              >
                <HeaderTypography
                  className="header"
                  color="#2e3f4f"
                  fontSize={{ sm: 13, xs: 13 }[width] || 18}
                  fontWeight={600}
                  m={0}
                  mr={{ sm: 2, xs: 1 }[width] || 2}
                  overrideClassName
                >
                  Book a FREE Demo
                </HeaderTypography>
                <MuiLink href="tel:+6597510475" onClick={conversionEventOnCall}>
                  <Box alignItems="center" display="flex">
                    <Box
                      alt="Call to PepperCloud"
                      component={"img"}
                      height={{ sm: 14, xs: 14 }[width] || 20}
                      mr={{ sm: 0, xs: 0 }[width] || 1}
                      src={callImg}
                    />
                    <ParagraphTypography
                      className={classes.whitespaceNowrap}
                      color="#0291ae"
                      fontSize={{ sm: 14, xs: 14 }[width] || 20}
                      fontWeight={700}
                      m={0}
                      overrideClassName
                    >
                      +65 97510475
                    </ParagraphTypography>
                  </Box>
                </MuiLink>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* Banner */}
      <Box className={classes.singaporeSmeBanner}>
        <div className={classes.singaporeSmeBannerRightImg}></div>
        <Container>
          <Grid alignItems="flex-start" container justify="center" mt={3}>
            <Grid item md={7} sm={12}>
              <Box>
                <Box>
                  <Grid
                    alignItems="flex-start"
                    className={classes.martop}
                    container
                    justifyContent="center"
                  >
                    <Grid item md={1}>
                      <StaticImage
                        alt="Sales CRM dashboard"
                        className={classes.img}
                        m={6}
                        pt={6}
                        src="../images/v2/campaigns/social.png"
                      />
                    </Grid>
                    <Grid item md={11} textAlign="left">
                      <ParagraphTypography
                        className={classes.smeBannerTxthead}
                        fontSize={21}
                        fontWeight={500}
                        pt={6}
                        // pr={{ sm: "0px", xs: "0px" }[width] || "8rem"}
                      >
                        Fully integrated with WhatsApp & Facebook
                      </ParagraphTypography>
                    </Grid>
                  </Grid>
                </Box>
                <HeaderTypography
                  fontSize={{ sm: 36, xs: 34 }[width] || 42}
                  fontWeight={600}
                  lineHeight={1.25}
                  mb={4}
                  mt={3}
                  overrideClassName
                >
                  A complete CRM system built around your business needs
                </HeaderTypography>
                <ParagraphTypography
                  className={classes.smeBannerTxt}
                  color="#2e3f4f"
                  component="h2"
                  fontFamily="'Poppins', sans-serif"
                  fontSize={18}
                  mb={3}
                  mt={0}
                  // pr={{ sm: "0px", xs: "0px" }[width] || "8rem"}
                >
                  Facebook and WhatsApp integrated CRM to track Leads, manage
                  Opportunities, and accelerate Business growth.
                </ParagraphTypography>
                <Box pr={{ sm: "0px", xs: "0px" }[width] || "3rem"}>
                  <Grid alignItems="center" container justifyContent="start">
                    <Grid item md={6} sm={12}>
                      <Box>
                        <List className={classes.nopadtpbtm} pl={0}>
                          {listOne.map((each) => (
                            <ListItem
                              alignItems="center"
                              className={classes.nopad}
                              key={each}
                            >
                              <ListItemIcon>
                                <CheckIcon className={classes.listItemIcon} />
                              </ListItemIcon>
                              <ListItemText className={classes.listItemText}>
                                {each}
                              </ListItemText>
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    </Grid>
                    <Grid item md={6} sm={12}>
                      <Box>
                        <List className={classes.nopadtpbtm} pl={0}>
                          {listTwo.map((each) => (
                            <ListItem
                              alignItems="center"
                              className={classes.nopad}
                              key={each}
                            >
                              <ListItemIcon>
                                <CheckIcon className={classes.listItemIcon} />
                              </ListItemIcon>
                              <ListItemText className={classes.listItemText}>
                                {each}
                              </ListItemText>
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <br />
                <Box display={{ sm: "block", xs: "block" }[width] || "flex"}>
                  <Box
                    alt="Sales CRM Software for SMEs"
                    component={"img"}
                    maxHeight="350px"
                    maxWidth="100%"
                    src={singaporeSmeTestimonialImg}
                  />
                  {/* <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    mr={{ sm: 0, xs: 0 }[width] || 4}
                  >
                    <ParagraphTypography color="#151D41" fontSize={18} pt={3}>
                      “Pepper Cloud CRM is a right mix of flexibility,
                      affordability, and ease of use. It is built for your sales
                      team, who can use it to optimise closure time and manage
                      sales pipeline.”
                    </ParagraphTypography>
                    <div>
                      <Box
                        alt="TechData Logo"
                        component="img"
                        height={20}
                        src={TechDataLogo}
                        width="auto"
                      />
                      <ParagraphTypography color="#151D41" fontSize={16} mt={1}>
                        <b>Yoon Kam Fei</b> , Managing Director
                      </ParagraphTypography>
                    </div>
                  </Box> */}
                </Box>
              </Box>
            </Grid>
            <Grid item md={5} sm={12}>
              <Box
                className={classes.singaporeSmeFromBox}
                px={1}
                textAlign="center"
              >
                <Box className={classes.singaporeSmeFrom} ref={myRef}>
                  <HeaderTypography
                    className={classes.singaporeSmeFromHeader}
                    color="#fff"
                    component="h1"
                    fontWeight={600}
                    m={0}
                    textAlign="center"
                  >
                    Avail up to <b className={classes.colorChange}>50%</b> business
                    grant
                  </HeaderTypography>
                  {success ? (
                    <Box p={8} textAlign="center">
                      <Box
                        alt="Pepper Cloud form success"
                        component={"img"}
                        mr={1}
                        src={formSuccessImg}
                        width="120px"
                      />
                      <HeaderTypography fontSize={18} my={2}>
                        Thank you for contacting us!
                      </HeaderTypography>
                      <ParagraphTypography
                        color="#2e3f4f"
                        fontSize={16}
                        letterSpacing={0.56}
                        lineHeight={1.56}
                        m={0}
                      >
                        We have received your enquiry and we will respond to you
                        within 24 hours.
                      </ParagraphTypography>
                      <br />
                      <Link to="/">
                        <HeaderTypography
                          color="#0291ae"
                          fontSize={14}
                          fontWeight={600}
                          m={0}
                        >
                          Click here to visit home page
                        </HeaderTypography>
                      </Link>
                    </Box>
                  ) : (
                    <GenericAdForm
                      handleSuccess={handleSuccess}
                      width={width}
                    />
                  )}
                  <Box
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                    pb={4}
                  >
                    <Box
                      fontFamily="Poppins"
                      fontSize={14}
                      fontWeight={500}
                      mr={3}
                    >
                      Call / WhatsApp
                    </Box>
                    <MuiLink
                      href="tel:+6597510475"
                      onClick={conversionEventOnCall}
                    >
                      <Box alignItems="center" display="flex">
                        <Box
                          alt="Call to PepperCloud"
                          component={"img"}
                          height={{ sm: 14, xs: 14 }[width] || 20}
                          mr={1}
                          src={callImg}
                        />
                        <ParagraphTypography
                          className={classes.whitespaceNowrap}
                          color="#0291ae"
                          fontSize={{ sm: 16, xs: 16 }[width] || 20}
                          fontWeight={700}
                          m={0}
                          overrideClassName
                        >
                          +65 97510475
                        </ParagraphTypography>
                      </Box>
                    </MuiLink>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <IMDALockup />

      {/* Content*/}
      <Box
        pb={8}
        pt={{ sm: 8, xs: 8 }[width] || 10}
        textAlign="center"
        className={classes.backgroundWhite}
      >
        <Container>
          <Box className={classes.marginAuto} maxWidth={960}>
            <HeaderTypography
              component="h2"
              fontSize={35}
              fontWeight={600}
              mb={3}
              mt={0}
            >
              Best sales CRM software for small businesses
            </HeaderTypography>
          </Box>
          <Box
            alt="CRM system for SMEs"
            component={"img"}
            maxWidth="100%"
            src={singaporeSmeSalesCRMImg}
          />
        </Container>
      </Box>

      {/* Content */}
      <Box textAlign="center">
        <Container>
          <HeaderTypography
            className={classes.pepperCloudCRMHelps}
            fontSize={35}
            fontWeight={600}
            mb={0}
            mt={0}
          >
            <span className={classes.pepperCloudCRMHelpsSpan} fontWeight={600}>
              Pepper Cloud CRM helps you to
            </span>
          </HeaderTypography>
        </Container>
      </Box>

      {/* Content */}
      <Box
        className={classes.pepperCloudCRMHelpsContent}
        py={{ sm: 4, xs: 3 }[width] || 8}
      >
        <Container>
          <Box className={classes.pepperCloudCRMHelpsContentListBox}>
            <ul className={classes.pepperCloudCRMHelpsContentList}>
              <li className={classes.pepperCloudCRMHelpsContentListItem}>
                <Box alignItems="center" display="flex">
                  <span
                    className={classes.pepperCloudCRMHelpsContentListItemSpan}
                  >
                    1
                  </span>
                  Close deals 5x faster
                </Box>
              </li>
              <li className={classes.pepperCloudCRMHelpsContentListItem}>
                <Box alignItems="center" display="flex">
                  <span
                    className={classes.pepperCloudCRMHelpsContentListItemSpan}
                  >
                    2
                  </span>
                  Double your leads
                </Box>
              </li>
              <li className={classes.pepperCloudCRMHelpsContentListItem}>
                <Box alignItems="center" display="flex">
                  <span
                    className={classes.pepperCloudCRMHelpsContentListItemSpan}
                  >
                    3
                  </span>
                  Make your sales team 3x efficient
                </Box>
              </li>
              <li className={classes.pepperCloudCRMHelpsContentListItem}>
                <Box alignItems="center" display="flex">
                  <span
                    className={classes.pepperCloudCRMHelpsContentListItemSpan}
                  >
                    4
                  </span>
                  Transform your business digitally
                </Box>
              </li>
            </ul>
          </Box>
        </Container>
      </Box>

      {/* content */}
      <Box className={classes.salesProcessCardGroup} pb={4}>
        <Container>
          <Box className={classes.marginAuto} maxWidth={760}>
            <HeaderTypography
              component="h2"
              fontSize={{ sm: 24, xs: 24 }[width] || 35}
              fontWeight={600}
              mt={6}
              textAlign="center"
            >
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Build your business in a whole new way with the most trusted sales
              CRM for SMEs
            </HeaderTypography>
          </Box>

          <br />

          <Box className={classes.marginAuto} maxWidth="1100px">
            {[
              {
                name: "Connected with WhatsApp & Facebook",
                img: ChannelImg,
                description: `Use the CRM to engage with your prospects on WhatsApp, Facebook, and other social media channels. Create your own templates. Send personal or bulk messages.`,
                altTxt: "Connected with WhatsApp & Facebook ",
              },
              {
                name: "Increase your Sales",
                img: salesManagement,
                description: `Skillfully manage your sales process and sales opportunities throughout the sales pipeline. Let the sales CRM capture your every customer interaction and provide you with a clear view of sales opportunities and real-time sales projections.`,
                altTxt: "sales management",
              },
              {
                name: "Generate Instant Quotation",
                img: quotationManagement,
                description: `Generate, send, and track quotations directly from your CRM system. Save time and efforts by using preset email templates and quotation formats.`,
                altTxt: "sales quotation",
              },
              {
                name: "Manage your Leads",
                img: salesForcasting,
                description: `Unveil the capabilities of in-built web forms and automatically capture the leads from your website and social media channels. Qualify your leads, track them efficiently, and convert them into opportunities within the CRM.`,
                altTxt: "sales leads",
              },
              {
                name: "Run Marketing Campaigns",
                img: campaignManagement,
                description: `Unleash the power of marketing campaigns and engage with your customers effectively. Segment your leads, craft your message, and blast through the CRM.`,
                altTxt: "sales campaign",
              },
              {
                name: "Empower Sales Team",
                img: teamManagement,
                description: `Track and manage your entire sales team with CRM. Categorise the teams by territories, product lines, etc and let them focus on sales closure.`,
                altTxt: "sales team",
              },
            ].map((each) => (
              <Card className={classes.salesProcessCard} key={each.name}>
                <CardHeader
                  avatar={
                    <Box
                      alt={each.altTxt}
                      component={"img"}
                      height={{ sm: "26px", xs: "26px" }[width] || "46px"}
                      src={each.img}
                    />
                  }
                  classes={{
                    root: classes.cardHeader,
                    avatar: classes.cardHeaderAvatar,
                  }}
                  subheader={
                    <ParagraphTypography
                      color="#000"
                      fontSize={16}
                      letterSpacing={0.56}
                      lineHeight={1.56}
                      m={0}
                      overrideClassName
                    >
                      {each.description}
                    </ParagraphTypography>
                  }
                  title={
                    <HeaderTypography
                      component="h3"
                      fontSize={{ sm: 18, xs: 18 }[width] || 18}
                      fontWeight={600}
                      mb={1}
                      mt={0}
                      overrideClassName
                    >
                      {each.name}
                    </HeaderTypography>
                  }
                />
              </Card>
            ))}
          </Box>
        </Container>
      </Box>
      <Box className={classes.ConnectCrm} marginBottom="0">
        <Box
          alignItems="center"
          component={Container}
          display="flex !important"
          flexDirection="column"
          marginBottom="0"
          my={{ md: 4 }}
          textAlign="center"
        >
          <HeaderTypography component="h2" fontWeight={600} m={{ md: 3 }}>
            Completely connected to your business
          </HeaderTypography>
          <Grid container spacing={6}>
            <Grid item md={2} />
            <Grid item md={8} xs={12}>
              <StaticImage
                alt="Sales CRM Software Integration"
                className={classes.img}
                m={6}
                src="../images/v2/home/social@3x.png"
              />
            </Grid>
          </Grid>
          <Box mb={6} mt={6} textAlign={{ sm: "center", xs: "center" }[width]}>
            <WhiteButton
              color="primary"
              mb={6}
              onClick={executeScroll}
              size="large"
              variant="contained"
            >
              Explore Channels
            </WhiteButton>
          </Box>
        </Box>
      </Box>
      <Grid container xs={12} className={classes.listContainer}>
        <Grid item xs={12} sm={5}>
          <Box className={classes.PCBenefits}>
            <Box className={classes.PCBenefitsText}>
              Here is how you can benefit with Pepper Cloud CRM
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} width="100%">
          <Box className={classes.PCBenefitsList}>
            <ul className={classes.listStyle}>
              {benefitsList.map((item, index) => {
                return (
                  <li>
                    <Box className={classes.listItemTextTitle}>
                      {item.title}
                    </Box>
                    <Box className={classes.listItemTextDescription}>
                      {item.description}
                    </Box>
                  </li>
                );
              })}
            </ul>
          </Box>
        </Grid>
      </Grid>

      {/* clients Sections */}
      <Box>
        <Container>
          <HeaderTypography
            className={classes.pepperCloudCRMHelps}
            component="h2"
            fontSize={35}
            fontWeight={600}
            my={4}
            textAlign="center"
          >
            <span className={classes.pepperCloudCRMHelpsSpan} fontWeight={600}>
              Many Singapore companies are growing with us
            </span>
          </HeaderTypography>
          <br />
          <br />
          <CompanyCarousel className={classes.cimg} />
        </Container>
      </Box>

      <Box>
        <Container>
          <Box mb={4} mt={10}>
            <Divider dark />
          </Box>
        </Container>
      </Box>

      {/* Testimonials */}
      <Box className={classes.IntegratedCRMBg}>
        <Container id="testimonial">
          <Box display="flex" justifyContent="center">
            <Box
              maxWidth={800}
              pb={{ sm: 2, xs: 2 }[width] || 6}
              pt={4}
              textAlign="center"
            >
              <HeaderTypography
                alignItems="center"
                display="flex"
                fontSize={35}
                fontWeight={600}
                justifyContent="center"
                lineHeight={1.2}
                mb={3}
                mt={0}
              >
                Here is why our customers love us
              </HeaderTypography>
            </Box>
          </Box>
          <Container>
            <LazyLoad offset={100} once>
              <PCLandingPageTestimonial dotPosition="bottom" />
            </LazyLoad>
          </Container>
          {/*</Hidden>*/}
        </Container>
      </Box>

      {/* Book a free demo */}
      <Box className={classes.requestDemoRoot} py={10} textAlign="center">
        <Box alignItems="center" display="flex" justifyContent="center">
          <HeaderTypography
            color="common.white"
            fontSize={35}
            fontWeight={600}
            maxWidth={550}
            my={0}
            textAlign="center"
          >
            Join our happy customers and increase your sales revenue
          </HeaderTypography>
        </Box>
        <Box mt={6} textAlign="center">
          <WhiteButton
            color="primary"
            mb={6}
            onClick={executeScroll}
            size="large"
            variant="contained"
          >
            Book a Free Demo
          </WhiteButton>
        </Box>
      </Box>

      {/* footer */}
      <Box py={5}>
        <Container>
          <Box textAlign="center">
            <Link to="/">
              <Box
                alt="Pepper Cloud - Best WhatsApp CRM Software"
                component={"img"}
                height="100px"
                src={Logo}
              />
            </Link>
            <ParagraphTypography
              color="#2e3f4f"
              fontFamily="Poppins"
              fontSize={{ sm: 14, xs: 14 }[width] || 20}
              m4={0}
            >
              #34-04, Tower 1, One Raffles Place, Singapore 048616
            </ParagraphTypography>
          </Box>
        </Container>
        <Box
          color="#cbcccd"
          textAlign="end"
          paddingRight="23px"
          className={classes.copyFooter}
        >
          © Pepper Cloud - Singapore's Best WhatsApp CRM Software 2023
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default GoogleAdV1;
